<template>
  <ol class="flex flex-wrap items-center gap-2" data-testid="pin-step-header">
    <li v-for="(item, index) in STEPS" :key="item.step" class="flex items-center gap-2">
      <span
        class="flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold"
        :class="badgeClass(item.step)"
        :data-testid="`pin-step-badge-${item.step}`"
      >
        <SVGIcon v-if="item.step < step" :path="mdiCheck" class="text-sm" />
        <template v-else>{{ item.step }}</template>
      </span>
      <span class="text-sm" :class="labelClass(item.step)">{{ item.label }}</span>
      <span v-if="index < STEPS.length - 1" class="mx-1 h-px w-6 bg-gray-200" />
    </li>
  </ol>
</template>

<script setup lang="ts">
import { mdiCheck } from '@mdi/js'
import SVGIcon from '@/components/SVGIcon.vue'
import type { PinStep } from './pinModalTypes'

const props = defineProps<{ step: PinStep }>()

const STEPS: { step: PinStep; label: string }[] = [
  { step: 1, label: 'Encontrar' },
  { step: 2, label: 'Posicionar' },
  { step: 3, label: 'Confirmar' }
]

/** O passo atual é o único preenchido; os concluídos ficam em check, os futuros em cinza. */
function badgeClass(step: PinStep): string {
  if (step === props.step) return 'bg-[#2F7F91] text-white'
  if (step < props.step) return 'bg-[#2F7F91]/10 text-[#2F7F91]'
  return 'bg-gray-100 text-gray-400'
}

function labelClass(step: PinStep): string {
  if (step === props.step) return 'font-semibold text-gray-800'
  if (step < props.step) return 'text-gray-600'
  return 'text-gray-400'
}
</script>
